export function ErrorBanner({ error }: { error: unknown }) {
  if (!error) return null;
  const message =
    error instanceof Error ? error.message : String(error ?? "Unknown error");
  return (
    <div role="alert" className="error-banner">
      {message}
    </div>
  );
}
